import { useTranslation } from 'react-i18next';

import { VStack, useVModal } from '@/package';
import { useReviewStore, useTaskFrameStore } from '@/store';

import { useReviewLabelInFrame } from './useFrame';

const useRejectModal = ({
  frameSeq,
  taskId,
  onSuccess,
  onFail,
}: {
  frameSeq: Numberlish;
  taskId: Numberlish;

  onSuccess?: () => void;
  onFail?: () => void;
}) => {
  const { openDangerConfirm } = useVModal();
  const { t } = useTranslation();
  const { getCurrentPcdIndexReviewBoxList, comment } = useReviewStore();
  const { currentFrame } = useTaskFrameStore();
  const reviewBoxList = getCurrentPcdIndexReviewBoxList();

  const { reject } = useReviewLabelInFrame({
    frameSeq: +frameSeq!,
    taskID: +taskId!,
  });

  const reviewReject = async () => {
    try {
      await reject({
        reviewComment: comment,
        workData: currentFrame?.workData,
        reviewData: reviewBoxList,
      });

      onSuccess?.();
    } catch (err: any) {
      console.warn(err);
      onFail?.();
    }
  };

  const openRejectModal = () => {
    openDangerConfirm({
      title: t('review.rejectButtonText.pioneership'),
      message: () => (
        <VStack className="w-full" gap={0.25}>
          <div className="text-body-xl">
            {t('review.rejectCurrentFrame.baggageman')}
          </div>
          <div className="text-body-lg text-gray-600">
            {t('review.rejectCurrentFrameDescription.tabebuia')}
          </div>
        </VStack>
      ),
      cancelText: t('modal.cancelButtonText.intimidate'),
      confirmText: t('review.rejectButtonText.pioneership'),
      onConfirm: () => reviewReject(),
    });
  };

  return { openRejectModal };
};

export default useRejectModal;
